export default function handleNavList() {
    let $navList = $('.NavList-list');

    if ($navList.length) {
        $navList.find('a').on('click', function() {
            var $this = $(this),
                id = this.getAttribute('href').substring(1), // remove #.
                $target = $('#\\#' + id).ensureMatches();

            $this.parent().siblings().removeClass('is-active').end().addClass('is-active');

            $target.siblings().not($target).addClass('is-hidden');
            $target.removeClass('is-hidden');

            $this.parents('.NavList').find('.CollapsedList').val('#' + id);

            $(window).trigger('heightChanged');
        });

        if (window.location.hash) {
            $navList.find('a[href="' + window.location.hash + '"]').trigger('click');
        }
    }
}
